<template>
  <div class="semsignsaas-box-pc">
    <!-- 头部banner -->
    <BannerForm
      :pcBgImg="pcBgImg"
      :landingPageName="landingPageName"
      :showForm="!showScrollForm"
      :logoSrc="logoSrc"
      title="免费试用"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
      setHeight="540"
    >
      <template slot="title">
        <div class="semsign-title-content">
          <div class="one-line">{{ titleOneLine }}</div>
          <div class="two-line">{{ titleTwoLine }}</div>
        </div>
      </template>
      <template slot="desc">
        <div class="semsign-desc">浙江省“最多跑一次”电子签指定供应商</div>
      </template>
    </BannerForm>
    <!-- banner下方信息 -->
    <div class="banner-bottom">
      <div class="content">
        <div class="item" v-for="(item, index) in bannerBottomData" :key="index">
          <div class="first-line-text">{{ item.firstLineText }}</div>
          <div class="second-line-text">{{ item.secondLineText }}</div>
        </div>
      </div>
    </div>
    <!-- 什么是有法律效力的电子印章？ -->
    <div class="semsignsaas-seal">
      <div class="title">什么是有法律效力的电子印章？</div>
      <div class="info">
        <img class="seal-img" src="@/assets/images/sem-signsaas/seal.png" alt="" />
      </div>
    </div>
    <!-- e签宝SaaS产品套餐 -->
    <div class="product-package">
      <SectionCard :isPcFlag="true" title="e签宝SaaS产品套餐">
        <div class="package-title-content">
          <div class="package-center">
            <div class="package-item" v-for="item in packageTitleData" :key="item.key">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
          <img class="connect-img" src="../../assets/images/sem-api/connect-one.png" alt="" />
        </div>
        <div class="remarks">合同计费方式：版本费+使用合同份数套餐计费，用量越大单价越低</div>
        <!-- 具体套餐 -->
        <div class="version">
          <div v-for="item in systemList" :key="item.title" class="version-item">
            <div class="top-img">
              <img :src="item.imgSrc" alt="不同产品版本" />
            </div>
            <div class="version-name">{{ item.title }}</div>

            <div class="btn-ask" @click="onBtnClick(item.buttonText)">
              {{ item.buttonText }}
            </div>
            <div class="desc">
              <p class="line1">{{ item.text1 }}</p>
              <p class="line22">{{ item.text2 }}</p>
              <p class="line33">{{ item.text3 }}</p>
            </div>
            <div class="kind">
              <div v-for="kid in item.kindList" :key="kid.text" class="kid-item">
                <img :src="kid.icon" style="margin-right: 0.3125vw" alt="小图标" />
                <span> {{ kid.text }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="button-operation">
          <div>
            <div class="btn mfsy" @click="showDialog">免费试用</div>
            <div class="desc">注册可得5份合同试用</div>
          </div>
          <div>
            <div class="btn zxzx" @click="OnlineConsultationClick">在线咨询</div>
            <div class="desc">如需购买或了解更多套餐</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 灵活产品与能力 -->
    <ProductPower class="product-power" @showDialog="showDialog" :title="productPower.title" :powerList="productPower.powerList" />
    <!-- 全生态系统连接 -->
    <div class="system-connections">
      <SectionCard :isPcFlag="true" title="全生态系统连接">
        <div class="system-connections-content">
          <div class="desc">支持多终端集成</div>
          <div class="content">
            <img class="connect-one-img" src="@/assets/images/sem-api/connect-one.png" alt="" />
            <img class="connect-two-img" src="@/assets/images/sem-api/connect-two.png" alt="" />
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">立即接入</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 行业解决方案 -->
    <SolutionList @showDialog="showDialog" :title="solutions.title" :solutionList="solutions.list" />
    <!-- 客户案例 -->
    <OrgList class="customer-cases" :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
    <!-- 关于e签宝 -->
    <div class="e-qianbao">
      <SectionCard bgColor="#fbfcfd" :isPcFlag="true" title="关于e签宝">
        <div class="content">
          <div class="left">
            <img class="cover-picture" src="@/assets/images/landing-semsign/cover-picture.png" alt="" />
          </div>
          <div class="right">
            <div class="line"></div>
            <div class="text">
              <div class="text-item" v-for="item in eQianBao" :key="item.key">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </SectionCard>
    </div>

    <!-- 左侧计算机小象 -->
    <LeftBar />
    <!-- 免费试用申请弹框 -->
    <UseDialog ref="dialog" :qrCodeUrl="qrCodeUrl" />
    <!-- 提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- 提交完成弹框 -->
    <SuccessFrom v-if="showSuccessDialog" @closeform="showSuccessDialog = false" :qrCodeImg="qrCodeImg" />
    <!-- 底部备案信息 -->
    <FooterBasis />
  </div>
</template>

<script>
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu'
export default {
  name: 'semsignsaas',
  mixins: [qiyuMixin],
  components: {
    BannerForm: () => import('@/components/BannerForm.vue'),
    ProductPower: () => import('@/views/extension/components/pc/ProductPower.vue'),
    SolutionList: () => import('@/views/extension/components/pc/SolutionList.vue'),
    OrgList: () => import('@/views/extension/components/pc/OrgList.vue'),
    LeftBar: () => import('@/components/LeftBar/index.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    Message: () => import('@/views/extension/components/pc/Message.vue'),
    FooterBasis: () => import('@/components/FooterBasis.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    SuccessFrom: () => import('@/components/saasApiSuccessForm.vue'),
  },
  data() {
    return {
      pcBgImg: require('../../assets/images/landing-semsign/banner-bg.png'),
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      showScrollForm: false,
      logoSrc: require('@/assets/images/real-estate/logo.png'),
      titleOneLine: '合法可靠的电子印章',
      titleTwoLine: '电子合同平台',

      bannerBottomData: dataList.bannerBottomData,
      packageTitleData: dataList.packageTitleData,
      electronicCard: dataList.electronicCard,
      productPower: dataList.productPower,
      eQianBao: dataList.eQianBao,
      solutions: dataList.solutions,
      orgList: dataList.orgList,
      systemList: dataList.systemList,

      qrCodeImg: require('@/assets/images/sem-local/deploy-process-qr-code.png'),

      showSuccessDialog: false,
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      timer: null,
      qrCodeUrl: 'https://trial-cdn.esign.cn/upload/2d75b584-16e4-5f12-82b7-0bfa9ca156c3!!1-14.png',
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },

    // 留资弹框
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    // 在线咨询
    OnlineConsultationClick() {
      // this.handleCustomerClick()
      this.handleNewBaiduService()
    },
    onBtnClick(type) {
      if (type === '在线咨询') this.handleNewBaiduService()
      if (type === '免费试用') this.showDialog()
    },
  },
}
</script>

<style lang="less" scoped>
@import './style.less';
</style>
